import { SeAnalyticsService } from 'se-analytics';
import { OverviewChartReportKey } from '../models/overview-chart';

export const VIEW_REPORT_EVENT_BY_KEY: Record<OverviewChartReportKey, string> = {
  payouts: 'view_report_payouts',
  receivables: 'view_report_receivables',
  sale_items: 'view_report_sale_items',
  adjustments: 'view_report_adjustments',
  payments_received: 'view_report_payments',
  refunds: 'view_report_refunds',
};

const REPORT_DEPTH3_BY_KEY: Record<OverviewChartReportKey, string> = {
  payouts: 'Payouts',
  receivables: 'Receivables',
  sale_items: 'SaleItems',
  adjustments: 'Adjustments',
  payments_received: 'Payments',
  refunds: 'Refunds',
};

const FINANCIAL_REPORTS_DEPTHS = {
  depth1: 'HQ',
  depth2: 'FinancialReports',
} as const;

// Tab navigation or direct URL into a report — screen view only (no custom event)
export function trackReportPageView(seAnalytics: SeAnalyticsService, reportKey: OverviewChartReportKey): void {
  seAnalytics.push({
    type: 'pageView',
    data: {
      ...FINANCIAL_REPORTS_DEPTHS,
      depth3: REPORT_DEPTH3_BY_KEY[reportKey],
    },
  });
}

// Landing on the Overview dashboard — screen view only
export function trackOverviewPageView(seAnalytics: SeAnalyticsService): void {
  seAnalytics.push({
    type: 'pageView',
    data: {
      ...FINANCIAL_REPORTS_DEPTHS,
      depth3: 'Overview',
    },
  });
}

// "View report" link on an Overview chart card — custom event with view_report_* name
export function trackOverviewViewReport(seAnalytics: SeAnalyticsService, reportKey: OverviewChartReportKey): void {
  const eventName = VIEW_REPORT_EVENT_BY_KEY[reportKey];

  seAnalytics.push({
    type: 'seEvent',
    data: {
      ...FINANCIAL_REPORTS_DEPTHS,
      depth3: REPORT_DEPTH3_BY_KEY[reportKey],
      action: eventName,
      event_name: eventName,
      event_type: 8,
    },
  });
}
